export const visibilityState = {
  authenticated: 'Authenticated',
  notAuthenticated: 'NOT_AUTHENTICATED',
  any: 'ANY',
};
